export const manifest = {
  screens: {
    scr_t0r3qd: { name: "Home — Calculator", route: "/", position: {"x":160,"y":220} },
    scr_2sbvzj: { name: "Pricing Comparison", route: "/compare", position: {"x":1560,"y":220} },
    scr_10tq22: { name: "Copilot Cost Guide", route: "/guides/copilot", position: {"x":160,"y":2200} },
    scr_ec5nff: { name: "Cursor Cost Guide", route: "/guides/cursor", position: {"x":1560,"y":2200} },
    scr_akv5xt: { name: "Claude Code Cost Guide", route: "/guides/claude-code", position: {"x":2960,"y":2200} },
    scr_j81nv3: { name: "Windsurf Cost Guide", route: "/guides/windsurf", position: {"x":4360,"y":2200} },
    scr_e9tklf: { name: "Track AI Coding Spend", route: "/track-spend", position: {"x":160,"y":4180} },
    scr_e1iqi5: { name: "AI Coding Tool Cost FAQ", route: "/faq", position: {"x":5760,"y":2200} },
  },
  sections: {
    sec_wuwfea: { name: "Main Calculator & Pricing", x: 0, y: 0, width: 2920, height: 1180 },
    sec_dszrut: { name: "Cost Guides", x: 0, y: 1980, width: 7120, height: 1180 },
    sec_a80ftv: { name: "Spend Tracking", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_wuwfea", children: [
      { kind: "screen", id: "scr_t0r3qd" },
      { kind: "screen", id: "scr_2sbvzj" },
    ] },
    { kind: "section", id: "sec_dszrut", children: [
      { kind: "screen", id: "scr_10tq22" },
      { kind: "screen", id: "scr_ec5nff" },
      { kind: "screen", id: "scr_akv5xt" },
      { kind: "screen", id: "scr_j81nv3" },
      { kind: "screen", id: "scr_e1iqi5" },
    ] },
    { kind: "section", id: "sec_a80ftv", children: [
      { kind: "screen", id: "scr_e9tklf" },
    ] },
  ],
}
